import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { LoadingIndicator } from 'components/styled/loading-indicator'
import { Box } from 'components/styled/containers/box'

/**
 * Component that will display spinner while action is fetching data.
 */

interface FetchWithSpinnerProps {
  action: () => any // for now, not sure about all the types the action can be
  /*  | Promise<void>
    | (() => (dispatch: any) => Promise<void>)
    | (() => void) */
  dispatch: any
  children: React.ReactElement<any, any> | null | any
}

export const FetchWithSpinner = ({
  action,
  dispatch,
  children,
}: FetchWithSpinnerProps) => {
  const [fetching, setFetching] = useState<boolean>(true)

  useEffect(() => {
    dispatch(action()).then(() => setFetching(false))
  }, [])

  if (fetching) {
    return (
      <Box mt="s96">
        <LoadingIndicator />
      </Box>
    )
  }
  return children
}

export default connect()(FetchWithSpinner)
